import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Leaders').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'stretch',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },

  imageContainer: {
    position: 'relative',
  },

  title: {
    textAlign: 'center',
    fontFamily: 'Inter',
    fontWeight: '600',
    fontSize: theme.sizes.texts.fontSize.xl,

    fontStyle: 'normal',
    lineHeight: '40px',
    color: theme.colors.text.primary,
  },
  tabList: {
    backgroundColor: '#2e2f34',
    position: 'sticky',
    opacity: '1',
    minHeight: '32px',
  },
  coinIcon: {
    height: '12px',
    width: '12px',
  },
  coinIcon2: {
    height: '16px',
    width: '16px',
  },

  header: {
    position: 'sticky',
    top: '40px',
    zIndex: '5',
    alignItems: 'center',
    height: '40px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'stretch',
    width: '100%',
    padding: '0px 32px',
    paddingBottom: '0px',
    color: theme.colors.text.secondary,
    background: theme.colors.background.primary,

    div: {
      display: 'flex',
      flexDirection: 'row',
    },
  },

  placeTittle: {
    alignItems: 'start',
    justifyContent: 'start',
    textAlign: 'start',
    width: '40%',

    fontSize: theme.sizes.texts.fontSize.xs,
    lineHeight: theme.sizes.texts.lineHeight.xs,

    fontWeight: 370,
  },

  nameTittle: {
    alignItems: 'start',
    justifyContent: 'start',
    textAlign: 'start',
    textTransform: 'uppercase',
    width: '100%',

    fontSize: theme.sizes.texts.fontSize.xs,
    lineHeight: theme.sizes.texts.lineHeight.xs,

    fontWeight: 370,
  },

  variant: {
    alignItems: 'start',
    justifyContent: 'end',
    textAlign: 'end',
    textTransform: 'uppercase',
    width: '100%',

    fontSize: theme.sizes.texts.fontSize.xs,
    lineHeight: theme.sizes.texts.lineHeight.xs,

    fontWeight: 370,
  },

  bgImage: {
    width: '100vw',
    height: '55vw',
    backgroundImage: 'url(/assets/backgrounds/LeaderboardBG.webp)',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  },

  tabListWrapper: {
    background: theme.colors.background.primary,
    display: 'flex',
    justifyContent: 'center',
    position: 'sticky',
    top: '0',
    marginTop: '36px',
    paddingTop: '8px',
    zIndex: '10',
    minHeight: '50px',
  },

  totalAccountValueWrapper: {
    position: 'absolute',
    display: 'flex',
    width: '100%',
    gap: '4px',
    paddingTop: '24px',
    alignSelf: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.colors.text.primary,
  },

  totalAccountValueText: {
    fontSize: '12px',
    fontWeight: 330,
    lineHeight: '14px',
  },

  totalAccountValue: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '38px',
  },

  //   emoji: {
  //     display: 'flex',
  //     alignItems: 'center',
  //     justifyContent: 'center',
  //     height: '40px',
  //     width: '40px',

  //     img: {
  //       width: '100%',
  //       height: '100%',
  //     },
  //   },
}))
